import { GALLERY } from "@/data/site";
import { PageHero } from "@/components/PageHero";
import { Lightbox } from "@/components/Lightbox";
import { CtaBanner } from "@/components/CtaBanner";

export default function Gallery() {
  return (
    <>
      <PageHero
        label="Gallery"
        title="Recent installations"
        subtitle="A look at real projects completed by the Access team — air conditioning, ducted systems, heat pump hot water and more."
        image={GALLERY[3].src}
        crumbs={[{ label: "Gallery" }]}
      />

      <section className="bg-white py-20 md:py-28">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <Lightbox images={GALLERY} />
        </div>
      </section>

      <CtaBanner />
    </>
  );
}
